<div id="excel-form-container" #excelcontainer class="excel-form-container">
  <wj-flex-sheet #flex (initialized)="initializeFlexSheet(flex)" (cellEditEnded)="onCellEditEnded($event)" (formatItem)="onFormatItem($event,dialogContentAddRow, flex)" (selectionChanged)="onSelectionChanged(flex,$event)">
  </wj-flex-sheet>
</div>
<div>
  <ngx-loading [show]="showLoader" [config]="{ backdropBackgroundColour: 'rgba(255, 255, 255, .8)' }"
  [template]="customLoadingTemplate1"></ngx-loading>
</div>
<div class="loader-container">
  <ng-template #customLoadingTemplate1>
    <div class="normal-loader-content">
      <div class="loader-image"></div>
    </div>
  </ng-template>
</div>
<ng-template #dialogContentAddRow>
  <div class="add-custom-header">
    <div class="head">
      <div class="title">
        Update Row
      </div>
      <div class="right-actions">
          <button mat-button  [mat-dialog-close]="true" color="accent" class="cancel-cta">
            Cancel
          </button>
          <button mat-flat-button (click)="updateRow()"  [mat-dialog-close]="true" color="primary" class="okay-cta">
            Update
          </button>
      </div>
    </div>
    <div class="content">
      <div class="config-card">
        <div class="config-card-body">
          <div class="row">
            <ng-container  *ngFor="let item of addNewRowColumns">
              <div class="col-md-4 col-lg-4 col-sm-4" *ngIf="item.label != 'isRowAdded'">
                <label class="config-key">{{item.label | camelCaseToSentence}}</label>
                <span class="config-text-input">
                  <input type="text" matInput [(ngModel)]="item.key" [disabled]="item.label == 'UniqueRowIdentifier'">
                </span>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>